import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import * as types from '@reservedb/store/types'
import * as accountTypes from '@account/store/types'
import { IEDate, uGetDateFormat } from '@/modules/@appbase/util';
import { EnumCalendarViewType } from '@reservedb/types'
@Component({
    computed: mapGetters({
        current: accountTypes.CURRENT,
        isLoading: types.CALENDAR_LOADING,
        isDailyEventLoading: types.CALENDAR_DAILYEVENT_LOADING,
        monthMatrix: types.MINI_CALENDAR_MONTH_MATRIX_LIST,
        calendarSetting: types.CALENDAR_SETTING,
        currentDate: types.CALENDAR_DATE_CURRENT,
        viewMode: types.CALENDAR_VIEWMODE,
    }),

    methods: mapActions({
        loadMiniCalendar: types.MINI_CALENDAR_MONTH_MATRIX_LOAD,
        selectDate: types.CALENDAR_DATE_SELECT,
        selectDateLoad: types.CALENDAR_DATE_SELECTRELOAD
    })
})
export default class MiniCalendar  extends Vue {
    loadMiniCalendar!: () => void;
    selectDate!: (payload: any) => Promise<any>;
    selectDateLoad!: (payload: any) => Promise<any>;
    viewMode!: EnumCalendarViewType

    current!: account.TCurrent;
    isLoading!: boolean;
    isDailyEventLoading!: boolean;
    currentDate!: reservedb.DateItem;
    calendarSetting!: reservedb.CalendarSetting;
    monthMatrix!: Array<Array<reservedb.DateItem>>;

    weekLabel: any = {
        0: { key: 0, text: this.$t("일").toString() },
        1: { key: 1, text: this.$t("월").toString() },
        2: { key: 2, text: this.$t("화").toString() },
        3: { key: 3, text: this.$t("수").toString() },
        4: { key: 4, text: this.$t("목").toString() },
        5: { key: 5, text: this.$t("금").toString() },
        6: { key: 6, text: this.$t("토").toString() }
    }
    
    weeklist: any[] = [];

    get currentMonthText() {
        return this.current.userConfig.language === 'ko-KR' ?
            uGetDateFormat('yyyy년 MM월', IEDate(this.currentDate.date)) :
            uGetDateFormat('MM/yyyy', IEDate(this.currentDate.date))
    }

    created() {
        this.mountWeekList();
        this.loadMiniCalendar();
    }

    mountWeekList() {
        this.weeklist = [];

        for(var i = 0; i < 7; i++) {
            var idx = (this.calendarSetting.firstDay + i) % 7;
            this.weeklist.push(this.weekLabel[idx]);            
        }         
    }

    onSelectDate(item: reservedb.DateItem) {
        if(this.isLoading || this.isDailyEventLoading)
            return;

        this.selectDate(item);
    }

    onPrevMonthClick() {
        if(this.isLoading || this.isDailyEventLoading)
            return;

        var prevItem: reservedb.DateItem = {
            ...this.currentDate
        }

        prevItem.date.setMonth(prevItem.date.getMonth() - 1);
        this.selectDateLoad(prevItem);
    }

    onNextMonthClick() {
        if(this.isLoading || this.isDailyEventLoading)
            return;

        var nextItem: reservedb.DateItem = {
            ...this.currentDate
        }

        nextItem.date.setMonth(nextItem.date.getMonth() + 1);
        this.selectDateLoad(nextItem);
    }

    onTodayClick() {
        if(this.isLoading || this.isDailyEventLoading)
            return;

        var todayItem: reservedb.DateItem = {
            ...this.currentDate,
            date: new Date()
        }

        this.selectDateLoad(todayItem);
    }

    @Watch("viewMode")
    onchangedViewMode(){
        this.selectDate(this.currentDate);
    }
}